var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoUmcMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.998,
    height: 22.386,
    viewBox: "0 0 65.998 22.386",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_UMC_mini",
    transform: "translate(579 335.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3785",
    "data-name": "Groupe 3785",
    transform: "translate(-579 -335.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_24",
    "data-name": "Trac\\xE9 24",
    d: "M146.452.194a13.081,13.081,0,0,0-8.235,3.155,10.8,10.8,0,0,1,1.2,3.8,8.641,8.641,0,0,1,6.226-2.932A5.655,5.655,0,0,1,149.695,5.8l5.084,0a8.518,8.518,0,0,0-8.327-5.61",
    transform: "translate(-88.781 -0.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_25",
    "data-name": "Trac\\xE9 25",
    d: "M93.689,16.827A8.194,8.194,0,0,1,89,18.4c-3.849,0-6.326-3.2-5.533-7.141h0C84.709,5.1,80.838.079,74.818.073A12.7,12.7,0,0,0,67.835,2.3a8.9,8.9,0,0,0-6.1-2.243,12.449,12.449,0,0,0-6.128,1.7l-1.1,5.477a8.7,8.7,0,0,1,6.421-3.15c3.849,0,6.326,3.2,5.533,7.14,0,.006,0,.011,0,.017h0L64.215,22.384l3.931,0,2.246-11.158a10.188,10.188,0,0,0-.477-5.937A8.008,8.008,0,0,1,74.008,4.1c3.849,0,6.326,3.2,5.533,7.14h0c0,.006,0,.012,0,.019h0C78.3,17.419,82.17,22.419,88.191,22.425a13.742,13.742,0,0,0,10.582-5.593Z",
    transform: "translate(-35.012 -0.039)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26",
    "data-name": "Trac\\xE9 26",
    d: "M55.61,7.007a9,9,0,0,1,4.444-2.544L60.877.372a12.8,12.8,0,0,0-4.214,1.4Z",
    transform: "translate(-35.72 -0.239)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_27",
    "data-name": "Trac\\xE9 27",
    d: "M19.14.015,16.086,15.186A8.686,8.686,0,0,1,9.7,18.3c-3.849,0-6.326-3.2-5.533-7.14,0-.006,0-.011,0-.017h0L6.409,0,2.478,0,.232,11.158c-1.24,6.163,2.634,11.163,8.654,11.168a12.443,12.443,0,0,0,6.1-1.684l-.34,1.689,3.931,0L23.071.019Z",
    transform: "translate(-0.001 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUmcMini);
export default __webpack_public_path__ + "static/media/logo_UMC_mini.b04a2406e0e8d5dc9088779523717aaf.svg";
export { ForwardRef as ReactComponent };